import * as React from "react";

import { useTranslation } from "react-i18next";

import { cn } from "../../../utils/cn";

import { FieldWrapper, FieldWrapperPassThroughProps } from "./field-wrapper";

export type Option = {
  optionLabel: React.ReactNode;
  optionValue: string | number | string[];
};

type BaseSelectProps = Omit<
  React.SelectHTMLAttributes<HTMLSelectElement>,
  "onChange" | "value"
> &
  FieldWrapperPassThroughProps & {
    options: Option[];
    className?: string;
  };

type ControlledSelectProps = {
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  value: string | number | string[];
};

type UncontrolledSelectProps = {
  onChange?: undefined;
  value?: string | number | string[];
};

type SelectFieldProps = BaseSelectProps &
  (ControlledSelectProps | UncontrolledSelectProps) & {
    isRequired?: boolean;
  };

export const Select = (props: SelectFieldProps) => {
  const { label, options, error, className, value, onChange, ...selectProps } = props;
  const { t } = useTranslation();

  return (
    <FieldWrapper label={label} error={error}>
      <select
        {...selectProps}
        className={cn("text-input with-border", className)}
        value={value}
        onChange={(e) => onChange?.(e)}
      >
        {options.map((option) => (
          <option
            key={option.optionValue.toString()}
            value={option.optionValue}
          >
            {t(`common:options.${option.optionLabel}`)}
          </option>
        ))}
      </select>
    </FieldWrapper>
  );
};